import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { CartProvider } from "@/context/CartContext";
import { Header } from "@/components/store/Header";
import { Footer } from "@/components/store/Footer";
import { ChatWidget } from "@/components/store/ChatWidget";
import { BottomNav } from "@/components/store/BottomNav";
import { ScrollToTop } from "@/components/store/ScrollToTop";
import Home from "@/pages/Home";
import GamePage from "@/pages/GamePage";
import Checkout from "@/pages/Checkout";
import OrderStatus from "@/pages/OrderStatus";
import CompleteOrder from "@/pages/CompleteOrder";
import Admin from "@/pages/Admin";
import MysteryBox from "@/pages/MysteryBox";
import Offers from "@/pages/Offers";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Faq from "@/pages/Faq";
import Policies from "@/pages/Policies";
import { SignInPage, SignUpPage } from "@/pages/AuthPages";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <ClerkAuthProvider>
          <CartProvider>
            <ScrollToTop />
            <Header />
            <main className="relative z-[2]">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/game/:id" element={<GamePage />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/policies" element={<Policies />} />
                <Route path="/shipping-policy" element={<Navigate to="/policies#shipping" replace />} />
                <Route path="/refund-policy" element={<Navigate to="/policies#refund" replace />} />
                <Route path="/return-policy" element={<Navigate to="/policies#return" replace />} />
                <Route path="/offers" element={<Offers />} />
                <Route path="/mystery" element={<MysteryBox />} />
                <Route path="/order" element={<OrderStatus />} />
                <Route path="/complete/:id" element={<CompleteOrder />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/sign-in/*" element={<SignInPage />} />
                <Route path="/sign-up/*" element={<SignUpPage />} />
              </Routes>
            </main>
            <Footer />
            <ChatWidget />
            <BottomNav />
            <Toaster theme="dark" position="top-center" richColors />
          </CartProvider>
        </ClerkAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
